import { Button, Divider } from "components";
import { useFormikContext } from "formik";
import { useBrand } from "hooks/useBrand";
import GoogleSignInButton from "pages/accounts-onboarding/components/google-signin-button";
import LegalConsentNote from "pages/accounts-onboarding/components/legal-consent-note";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import Paths from "routes/Paths";

import type { LoginFormModel } from "../../models";

import styles from "../Login.module.css";

const LoginFooter = () => {
	const { t } = useTranslation("accountsPage");
	const brand = useBrand();
	const { isSubmitting } = useFormikContext<LoginFormModel>();
	// Keep the post-sign-in redirect when switching to the register form.
	const { search } = useLocation();

	return (
		<footer className={styles.footer}>
			<Button disabled={isSubmitting} type="submit" fullWidth>
				{t("login.submit")}
			</Button>
			<Divider label={t("continueWith")} />
			<GoogleSignInButton />
			<div className={styles.register}>
				<span>{t("login.noAccount", brand)}</span>
				<Link className={styles.registerLink} to={{ pathname: Paths.signUp, search }}>
					{t("login.createAccount")}
				</Link>
			</div>
			<LegalConsentNote action="signIn" />
		</footer>
	);
};

export default LoginFooter;
